import AddIcon from '@material-ui/icons/Add';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import PersonIcon from '@material-ui/icons/Person';
import _ from 'lodash';
import Grid from '../../../Common/Grid';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';

import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';

import styles from './styles';

import Icon from '../../../Common/Icon';
import { isDialogVisibleSelector } from '../../../../redux/selectors';
import { CONFIRM_DIALOG, STAGE_DIALOG } from '../../../../redux/constants/dialogs';

const COLUMNS = [
  { name: 'icon', title: ' ' },
  { name: 'name', title: 'Name' },
  { name: 'qa', title: 'QA' },
  // { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'icon', width: 80 },
  { columnName: 'name', width: 200 },
  { columnName: 'qa', width: 100 },
  // { columnName: 'email', width: 150 },
  // { columnName: 'action', width: 80 },
];

const getCellComponent = ({ column, value, row }) => {
  switch (column.name) {
    case 'icon':
      return value ? <Icon name={value} style={styles.stageIcon}/> : null;
    case 'name':
      return value;
    case 'qa':
      return value && value.questions && value.questions.length ? 'Yes' : 'No';
    default:
      return value;
  }
};

class StagesGrid extends Component {
  state = {};

  componentWillMount() {
  }

  handleSave = (stage) => {
    console.log('handleSave', stage);
    let found = false;
    const stages = this.props.stages.map((s) => {
      if (stage.id === s.id) {
        found = true;
        return stage;
      }

      return s;
    });

    if (!found) {
      stages.push(stage);
    }

    this.props.onChange(stages);
  };

  handleEdit = (stage) => {
    this.props.showDialog(STAGE_DIALOG, { stage, onSave: this.handleSave });
  };

  handleRemove = (stage) => {
    const context = {
      type: 'warning',
      title: 'Remove Stage?',
      message: 'Are you sure you wish to remove this stage?',
      buttons: [
        <Button
          key="cancel"
          variant="text"
          onClick={() => this.props.hideDialog(CONFIRM_DIALOG)}
        >Cancel</Button>,
        <Button
          key="confirm"
          variant="text"
          onClick={() => {
            this.props.hideDialog(CONFIRM_DIALOG);
            this.props.onChange(this.props.stages.filter((r) => r.id !== stage.id));
          }}
        >Remove</Button>,
      ],
    };

    this.props.showDialog(CONFIRM_DIALOG, context);
  };

  render() {
    const { stages, showDialog } = this.props;
    const buttons = [<Tooltip key="create" title="Add Stage">
      <Fab
        color="secondary"
        aria-label="add"
        style={styles.add}
        onClick={() => showDialog(STAGE_DIALOG, { onSave: this.handleSave })}
        size="small"
        id="addStage"
        key="add"
      >
        <AddIcon/>
      </Fab>
    </Tooltip>];

    return (<Grid
      buttons={buttons}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      data={{ data: stages }}
      fetch={_.noop}
      onEdit={(stage) => this.props.showDialog(STAGE_DIALOG, { stage, onSave: this.handleSave })}
      onRemove={this.handleRemove}
      cellComponent={getCellComponent}
      noDataCellComponent={getNoDataCellComponent(<PersonIcon style={styles.noData}/>, 'stages')}
    />);
  }
}

StagesGrid.propTypes = {
  stages: PropTypes.array,
  onChange: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    // jobProfile: state.get('jobprofiles').get('jobProfile').toJS(),
    // initialValues: state.get('jobprofiles').get('jobProfile').toJS(),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StagesGrid);



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/StagesGrid/index.js